import SectionalGateForm from "./SectionalGateForm";

export default SectionalGateForm